import { API_BASE, ODATA_BASE } from "helpers/api_config";
import { gorselYuklemeParametreleri } from "helpers/gorselKucult";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { toastError } from "helpers/toast";
import {
  optionalUrl,
  requiredText,
} from "helpers/validators";
import { useFormik } from "formik";
import { NameSurname, Status } from "./contactlistCol";


//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import AdSlotGuide from "components/Common/AdSlotGuide";
import { AD_SYSTEM, findSlot, slotNoText } from "helpers/adSlots";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import "jspdf-autotable";
import Dropzone from 'react-dropzone-uploader';

import {
  getAdvertesing as onGetAdverting,
  addAdvertesing as onAddAdvertesing,
  updateAdvertesing as onUpdateAdvertesing,
  deleteAdvertesing as onDeleteAdvertesing,
} from "store/contacts/actions";
import { isEmpty } from "lodash";
//redux
import { useSelector, useDispatch } from "react-redux";

import SayfaRehberi from "../../../components/Common/SayfaRehberi";
/** Advert_Desc icine yedeklenen "span:N" degerini okur (yoksa 1). */
const readSpanFromDesc = desc => {
  const match = /span:(\d+)/.exec(String(desc || ""));
  const value = match ? parseInt(match[1], 10) : 1;
  return Math.min(Math.max(value || 1, 1), 3);
};

const ContactsList = props => {

  //meta title
  document.title = "Liste Arası Reklamlar | BERLİN ESNAF ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();

  const [getFileName, setFileName] = useState(null);
  const [getFileType, setFileType] = useState(null);

  const [getNewsID, setNewsID] = useState(null);
  // Anasayfa reklam panosunda kac kutucuk yukseklik kaplayacagi (1/2/3)
  const [getSpan, setSpan] = useState(1);
  // API'de Advert_Span kolonu var mi? ($metadata'dan bir kez ogreniliyor)
  // Kolon yokken bu alan gonderilirse OData 500 doner ve reklam HIC kaydedilmez.
  // Varsayilan "destekleniyor": kolon 2026-08-19'da API'ye eklendi; $metadata
  // okunamazsa (ag/CORS) yukseklik yine de kaydedilsin diye iyimser basliyoruz.
  const [spanSupported, setSpanSupported] = useState(true);

  const [getNews, setNews] = useState([]);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      title: (contactEdit && contactEdit.Advert_Title) || "",
      link: (contactEdit && contactEdit.Advert_Link) || "",

    },
    validationSchema: Yup.object({
      title: requiredText("Başlık"),
      link: optionalUrl("Yönlendirme linki"),
    }),
    onSubmit: values => {
      // Kategori ve gorsel olmadan kaydedilen reklam uygulamada hic gorunmuyor;
      // sessizce bos kayit olusmasin diye burada uyariyoruz.
      if (!getNewsID) {
        toastError("Lütfen reklam kategorisi seçiniz.");
        return;
      }
      if (!getFileName) {
        toastError("Lütfen reklam görselini (veya videosunu) yükleyiniz.");
        return;
      }
      // Liste aralarindaki reklamlar gosterim tipi olmadan hicbir yere
      // yerlestirilemiyor -> tip secilmediyse varsayilan "her 3 kayitta bir".
      const showType =
        getNewsID == 1 || getNewsID == 2 ? getShowType || "every-3" : getShowType;

      const span = parseInt(getSpan, 10) || 1;

      const payload = {
        Advert_Url: getFileName,
        Advert_Title: values.title,
        Advert_Type: showType,
        ManualPosition: showType === "manual" ? parseInt(manualPosition) : null,
        Advert_Category_ID: parseInt(getNewsID, 10),
        Advert_Link: values.link,
        Advert_UrlType: getFileType,
        // Yukseklik: Advert_Span kolonu API'ye deploy edildiyse oraya yaziliyor.
        // Deploy edilmediyse (su anki durum) kullanilmayan Advert_Desc alanina
        // "span:N" olarak yaziliyor; mobil taraf ikisini de okuyor.
        Advert_Desc: `span:${span}`,
      };
      if (spanSupported) payload.Advert_Span = span;

      if (isEdit) {
        payload.ID = contactEdit.ID;
        dispatch(onUpdateAdvertesing(payload));
        setIsEdit(false);
        validation.resetForm();
      } else {
        dispatch(onAddAdvertesing(payload));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { advertesing } = useSelector(state => ({
    advertesing: state.contacts.advertesing,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);

  const [isEdit, setIsEdit] = useState(false);

  // Formda secili alanin rehber kaydi (aciklama kutusu icin)
  const selectedSlot = useMemo(() => {
    const found = (getNews || []).find(c => String(c.ID) === String(getNewsID));
    return found ? findSlot(AD_SYSTEM.ADVERT, found.Advert_Category_Title) : null;
  }, [getNews, getNewsID]);



  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },


      {
        Header: "Foto",
        // accessor: "name",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.Advert_Url ? (
              <div className="avatar-xs">
                {cellProps.Advert_Title != null ? <span className="avatar-title ">
                  {cellProps.Advert_Title.charAt(0)}
                </span> : null}
              </div>
            ) : (
              <div>

{cellProps.Advert_UrlType && cellProps.Advert_UrlType.startsWith("video") ? (
      <video height="200" controls>
        <source src={'https://megasubdomain.stechomeyazilim.info/' + cellProps.Advert_Url} type={cellProps.Advert_UrlType} />
        Tarayıcınız video etiketini desteklemiyor.
      </video>
    ) : (
      <img
        className="avatar-xl"
        src={'https://megasubdomain.stechomeyazilim.info/' + cellProps.Advert_Url}
        alt=""
      />
    )}

              </div>
            )}
          </>
        ),
      },

      {
        Header: "Başlık",
        accessor: "Advert_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        // Reklamin uygulamada nereye dustugunu gosteren sabit numara
        // (bkz. helpers/adSlots.js).
        Header: "Alan No",
        id: "adSlotNo",
        disableFilters: true,
        accessor: row =>
          (row.Advert_Category && row.Advert_Category.Advert_Category_Title) || "",
        Cell: cellProps => {
          const slot = findSlot(AD_SYSTEM.ADVERT, cellProps.value);
          if (!slot) {
            return (
              <span className="badge badge-soft-danger font-size-11">?</span>
            );
          }
          return (
            <div style={{ minWidth: 120 }}>
              <span className="badge badge-soft-primary font-size-12">
                {slotNoText(slot.no)}
              </span>
              <div className="text-muted font-size-11 mt-1">{slot.where}</div>
            </div>
          );
        },
      },

      {
        Header: "Reklam Kategorisi",
        accessor: "Advert_Category.Advert_Category_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Link",
        accessor: "Advert_Link",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },


      {
        Header: "Reklam Tipi",
        accessor: "Advert_UrlType",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      
      {
        Header: "Tipi",
        accessor: "Advert_Type",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        // Anasayfa reklam panosunda kapladigi yukseklik
        Header: "Yükseklik",
        filterable: false,
        accessor: row => `${row.Advert_Span || readSpanFromDesc(row.Advert_Desc)} kutucuk`,
      },


      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">

             
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );



  // API'de Advert_Span kolonu olup olmadigini $metadata'dan ogreniyoruz.
  // (Kolon EDMX'e eklenip API yeniden yayinlandiginda otomatik olarak aktif olur.)
  const _checkSpanSupport = async () => {
    try {
      const res = await axios.get(`${ODATA_BASE}/$metadata`, { responseType: "text" });
      setSpanSupported(String(res.data).includes('Name="Advert_Span"'));
    } catch (e) {
      // Metadata okunamadi: iyimser varsayimda kaliyoruz (Advert_Desc yedegi zaten yaziliyor)
    }
  };

  const _getNewsData = async () => {

    // Bu sayfa Advert tablosunu yonetir; kategorileri Advert_Category'de
    // (İlanlar / Firma Rehberi / Anasayfa). Advertesing_Category BASKA bir tablo.
    await axios.get(`${ODATA_BASE}/Advert_Category`)
      .then((res) => {
        setNews(res.data.value || [])
      })
  }

  useEffect(() => {
    _getNewsData()
    _checkSpanSupport()
  }, []); // sadece mount: dep icinde set edilen state vardi -> sonsuz dongu


  useEffect(() => {
    if (advertesing && !advertesing.length) {
      dispatch(onGetAdverting());
      setIsEdit(false);
    }
  }, [dispatch, advertesing]);

  // NOT: Burada eskiden `setContact(advertesing)` çağıran iki useEffect vardı.
  // `contact` seçilen SATIRI tutuyor; liste her değiştiğinde tüm dizi ile
  // eziliyordu. Dizide `.ID` olmadığı için silme fonksiyonundaki
  // `if (contact && contact.ID)` koşulu hiç sağlanmıyor ve silme sessizce
  // hiçbir şey yapmıyordu.

  const toggle = () => {
    setModal(!modal);
  };

  const toggleMedia = () => {
    setModalMedia(!modalMedia);
  };




  const handleUserClick = (arg) => {
    const user = arg;

    setEditContact(user);

    setManualPosition(arg.ManualPosition)
    
    setShowType(arg.Advert_Type)
    setFileName(arg.Advert_Url)

    setNewsID(arg.Advert_Category_ID)
    setSpan(arg.Advert_Span || readSpanFromDesc(arg.Advert_Desc))
    setFileType(arg.Advert_UrlType)

    setEditContact(user);

    setIsEdit(true);
    toggle();
  };

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = sliders => {
    setContact(sliders);
    setDeleteModal(true);
  };

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteAdvertesing(contact.ID));
    }
    setContact(undefined);
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    // Yeni kayit: onceki duzenlemeden kalan gorsel/kategori bilgileri
    // temizlenmezse yeni reklam eski gorselle kaydediliyordu.
    setEditContact(null);
    setFileName(null);
    setFileType(null);
    setNewsID(null);
    setShowType("");
    setManualPosition("");
    setSpan(1);
    setIsEdit(false);
    toggle();
  };



  const _setChoiceNews = arg => {
    setNewsID(arg.target.value)
  }


  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }



  const [getShowType, setShowType] = useState("");
  const [manualPosition, setManualPosition] = useState("");


  // Gorseller yuklenmeden once kucultulur (bkz. helpers/gorselKucult.js)
  const getUploadParams = gorselYuklemeParametreleri


  const handleChangeStatus = ({ file, xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          console.log("şmslşdf",result)
          console.log("filefile",file)

          setFileName(result.file.filename)
          setFileType(file.type);            // örnek: 'image/png', 'video/mp4'

        }
      }
    }
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Liste Arası Reklamlar" />
          <SayfaRehberi sayfa="PopupList" />

          <div className="mb-3">
            <AdSlotGuide highlightSystem={AD_SYSTEM.ADVERT} />
          </div>

          {/* Iki ayri "Reklamlar" sayfasi karisiyordu; hangisinin ne yaptigi burada yaziyor */}
          <div className="alert alert-info py-2 font-size-13">
            <i className="bx bx-info-circle align-middle me-1" />
            Bu sayfa <strong>liste aralarına serpiştirilen</strong> reklamları yönetir
            (her 2/3 kayıtta bir veya elle konumlandırılmış).
            Uygulamadaki <strong>banner alanları ve reklam talepleri</strong> için
            &quot;Reklam Alanları / Talepler&quot; sayfasını kullanın.
            <div className="mt-1">
              Not: İlan listesinde araya reklam yerleştirme mobil tarafta kapalıdır;
              bu kayıtlar şu an yalnızca <strong>Firma Rehberi</strong> listesinde gösterilir.
            </div>
          </div>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={advertesing}
                    isGlobalFilter={true}
                    isAddSlider={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />
             
             
                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Düzenle" : "Reklam Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>



                            <div className="mb-3">
                              <Label className="form-label">Başlık</Label>
                              <Input
                                name="title"
                                label="title"
                                type="text"
                                placeholder="Başlık Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>


                            <div className="mb-3">
                              <Label className="form-label">Link</Label>
                              <Input
                                name="link"
                                label="link"
                                type="text"
                                placeholder="Link Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.link || ""}
                                invalid={
                                  validation.touched.link &&
                                    validation.errors.link
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.link &&
                                validation.errors.link ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.link}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">
                                Reklam Alanı Seçiniz (Alan No)
                              </Label>
                              <Input

                                type="select"
                                className="form-select"
                                defaultValue={getNewsID}
                                onChange={(text) => _setChoiceNews(text)}
                                value={
                                  getNewsID
                                }>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getNews.map((item, index) => {
                                  const slot = findSlot(
                                    AD_SYSTEM.ADVERT,
                                    item.Advert_Category_Title
                                  );
                                  const label = slot
                                    ? `${slotNoText(slot.no)} · ${item.Advert_Category_Title} — ${slot.where}`
                                    : item.Advert_Category_Title;
                                  return (
                                    <option value={item.ID} key={item.ID}>
                                      {label}
                                    </option>
                                  );
                                })}

                              </Input>

                              {/* Secilen alanin uygulamada tam olarak nerede
                                  gorunecegi */}
                              {selectedSlot ? (
                                <div className="alert alert-info mt-2 mb-0 font-size-12">
                                  <div>
                                    <strong>
                                      Alan {slotNoText(selectedSlot.no)}
                                    </strong>{" "}
                                    — {selectedSlot.where}
                                  </div>
                                  <div className="mt-1">
                                    Gösterim: {selectedSlot.format}
                                  </div>
                                </div>
                              ) : null}
                            </div>

                            {/* Yukseklik yalnizca Anasayfa panosu icin anlamli */}
                            <div className="mb-3" style={{ display: getNewsID == 3 ? "block" : "none" }}>
                              <Label className="form-label">Yükseklik (Anasayfa reklam panosu)</Label>
                              <Input
                                type="select"
                                className="form-select"
                                value={getSpan}
                                onChange={(e) => setSpan(e.target.value)}
                              >
                                <option value="1">1 kutucuk (küçük banner)</option>
                                <option value="2">2 kutucuk (orta)</option>
                                <option value="3">3 kutucuk (büyük)</option>
                              </Input>
                              <small className="text-muted">
                                Reklam tam genişlikte gösterilir; bu ayar yüksekliği belirler.
                                {!spanSupported && " (API'de Advert_Span kolonu henüz yok; değer geçici olarak açıklama alanında saklanıyor.)"}
                              </small>
                            </div>

                           {/* Gosterim tipi sadece liste ekranlarinda (İlanlar / Firma Rehberi) kullaniliyor */}
                           { getNewsID == 1 || getNewsID == 2 ?
                            <div className="mb-3">
  <Label className="form-label">Reklam Gösterim Tipi</Label>
  <Input
    type="select"
    value={getShowType}
    onChange={(e) => setShowType(e.target.value)}
  >
    <option value="">Seçilmezse: Her 3 kayıtta bir</option>
    <option value="every-3">Her 3 haberde bir(tek)</option>
    <option value="every-2">Her 2 haberde bir(çift)</option>
    <option value="manual">Manuel pozisyon</option>
  </Input>
  <small className="text-muted">
    Bu ayar reklamın liste içinde hangi sıralarda görüneceğini belirler.
  </small>
</div> : null}

{getShowType === "manual" && (
  <div className="mb-3">
    <Label className="form-label">Pozisyon Sırası</Label>
    <Input
      type="number"
      min="1"
      value={manualPosition}
      onChange={(e) => setManualPosition(e.target.value)}
      placeholder="Kaçıncı sırada gösterilsin?"
    />
  </div>
)}



                            <div className="mb-3">
                              <Col xs={12} className="mb-3">
                                <label htmlFor="resume">Görsel</label>
                                <Dropzone
                                  getUploadParams={getUploadParams}
                                  onChangeStatus={handleChangeStatus}
                                  styles={{
                                    dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                    inputLabelWithFiles: { margin: '20px 3%' }
                                  }}

                                  canRemove={false}
                                  PreviewComponent={Preview}
                                  accept="image/*,video/mp4,video/webm,video/ogg,image/gif"
                                  />

                              </Col>

                              {getFileName != null ? (
  <div>
    {getFileType && getFileType.startsWith("video") ? (
      <video height="200" controls>
        <source src={'https://megasubdomain.stechomeyazilim.info/' + getFileName} type={getFileType} />
        Tarayıcınız video etiketini desteklemiyor.
      </video>
    ) : (
      <img
        className="avatar-xl"
        src={'https://megasubdomain.stechomeyazilim.info/' + getFileName}
        alt=""
      />
    )}
  </div>
) : null}


                            </div>


                  

                          </Col>
                        </Row>
                        <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
